import React from 'react'

import {
  createColumnHelper,
  getCoreRowModel,
  useReactTable,
} from '@tanstack/react-table'
import { useTranslation } from 'react-i18next'

import { Box, DataTable } from '@enechain/ecloud-designsystem'
import { getTextAlignLightTableStyle } from '@enechain/eposition-ui'

import { ResultAvailableDealSimulationForOption1Models } from '~/pages/Simulation/models/SimulationResultModel/ResultAvailableDealSimulationDetailForOption1Models'

type Props = {
  resultDetail: ResultAvailableDealSimulationForOption1Models
}

export const ResultLatestPositionForOption1Table: React.FC<Props> = ({
  resultDetail,
}) => {
  const { t } = useTranslation(['page', 'common', 'domain'])
  const columnHelper =
    createColumnHelper<ResultAvailableDealSimulationForOption1Models>()

  const columns = React.useMemo(
    () => [
      columnHelper.accessor('collateralAmount', {
        header: t('page:simulation.total_collateral'),
        cell: (info) => <Box>{info.getValue()}</Box>,
        enableSorting: false,
        meta: getTextAlignLightTableStyle(),
      }),
      columnHelper.accessor('totalCreditAmount', {
        header: t('page:simulation.total_credit'),
        cell: (info) => <Box>{info.getValue()}</Box>,
        enableSorting: false,
        meta: getTextAlignLightTableStyle(),
      }),
    ],
    [columnHelper, t],
  )

  const data = React.useMemo(
    () => (resultDetail !== undefined ? [resultDetail] : []),
    [resultDetail],
  )

  const table = useReactTable({
    columns,
    data,
    getCoreRowModel: getCoreRowModel(),
  })

  return (
    <DataTable
      table={table}
      emptyComponent={
        <Box width="100%" textAlign="center">
          {t('common:error.empty_data')}
        </Box>
      }
    />
  )
}
